// Absolute paths: a relative one is resolved against the page's folder (/comecar/images/tag.png on /comecar/...)
const urls = ["/images/ga.png", "/images/pixel.png", "/images/tag.png"];

/** Warms the browser's cache with the images some screens use. Best effort: a failed one is no error for the app. */
export const fetch = () => {
  const promises = urls.map(url => {
    return new Promise<void>(resolve => {
      const image = new Image();
      image.src = url;
      image.onload = () => resolve();
      image.onerror = () => resolve();
    });
  });
  return Promise.all(promises);
};
